var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPenIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.9419 1.06006C22.2621 0.38126 21.3406 0 20.3799 0C19.4192 0 18.4978 0.38126 17.8179 1.06006L0.00195312 18.876V24H5.12595L22.9419 6.18406C23.6205 5.50408 24.0016 4.58269 24.0016 3.62206C24.0016 2.66143 23.6205 1.74004 22.9419 1.06006ZM4.30195 22H2.00195V19.7L15.3119 6.40006L17.6119 8.70005L4.30195 22ZM21.5279 4.77006L19.0209 7.27706L16.7259 4.97706L19.2319 2.47406C19.5369 2.16906 19.9506 1.99772 20.3819 1.99772C20.8133 1.99772 21.2269 2.16906 21.5319 2.47406C21.8369 2.77906 22.0083 3.19273 22.0083 3.62406C22.0083 4.05539 21.8369 4.46906 21.5319 4.77406L21.5279 4.77006Z",
    fill: "#014D6C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPenIcon);
export default __webpack_public_path__ + "static/media/pen-icon.9e80bcc678047a863b2ce234dd838737.svg";
export { ForwardRef as ReactComponent };